import { styled, Switch } from '@mui/material'

const CustomTwoValueSwitch = styled( Switch )( ( { theme } ) => ( {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: theme.palette.primary.main,
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.background.paper,
                ...theme.applyStyles( 'dark', {
                    backgroundColor: theme.palette.background.paper,
                } ),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create( ['width'], {
            duration: 200,
        } ),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
        ...theme.applyStyles( 'dark', {
            backgroundColor: 'rgba(255,255,255,.35)',
        } ),
    },
} ) )

export default CustomTwoValueSwitch